// extracted by mini-css-extract-plugin
export default {"slide":"img_slide__w--wx","background":"img_background__+bq2w","title":"img_title__dg1IC","control":"img_control__PEsSX","selected":"img_selected__Tbwmj","arrow":"img_arrow__UOWUI"};